import { Routes } from '@angular/router';

export const COMPANIES_ROUTES: Routes = [
  {
    path: 'companies',
    loadComponent: () =>
      import('./companies-list/companies-list.component')
        .then(m => m.CompaniesListComponent),
  },
  {
    path: 'companies/create',
    loadComponent: () =>
      import('./companies-form/companies-form.component')
        .then(m => m.CompaniesFormComponent),
  },
  {
    path: 'companies/edit/:id',
    loadComponent: () =>
      import('./companies-form/companies-form.component')
        .then(m => m.CompaniesFormComponent),
  },
];
